import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {DesignUploadedImage} from '@mintdata-wsp/common/state/ui/visualDesigner/assets/DesignAssetsState';
import {UploadedImage} from '@mintdata/mint-kit/api/assets/UploadedImage';
import {IPromiseCancelable, PromiseUtil} from '@mintdata/mint-kit/impl/util/PromiseUtil';
import bind from 'bind-decorator';
import {action} from 'mobx';

export class UploadedImagesController
{
    @bind
    public getUploadedImages():IPromiseCancelable<UploadedImage[]>
    {
        return PromiseUtil.makeCancelable(this._getUploadedImages());
    }

    @bind
    public searchUploadedImages(text:string, uploadedImages?:UploadedImage[]):IPromiseCancelable<UploadedImage[]>
    {
        return PromiseUtil.makeCancelable(this._searchUploadedImages(text, uploadedImages));
    }

    @bind
    public getUploadedImage(name:string):IPromiseCancelable<UploadedImage>
    {
        return PromiseUtil.makeCancelable(this._getUploadedImage(name));
    }

    @bind
    public getUploadedImageByUrl(url:string):UploadedImage
    {
        const openDesign = commonControllers.designState.getOpenDesign();

        if( openDesign )
        {
            const designUploadedImage:DesignUploadedImage = openDesign.designState.assets.uploadedImages.find((
                (uploadedImage:DesignUploadedImage) => uploadedImage.url === url
            ));

            if( designUploadedImage )
                return this._deserializeUploadedImageSnapshot(designUploadedImage);
        }

        return null;
    }

    @action.bound
    public saveUploadedImage(name:string, label:string, url:string):void
    {
        const openDesign = commonControllers.designState.getOpenDesign();

        if( openDesign )
        {
            const {uploadedImages} = openDesign.designState.assets;

            const existing:DesignUploadedImage = uploadedImages.find((item) => item.name === name);

            if( !existing )
                uploadedImages.unshift(new DesignUploadedImage(name, label, url));
        }
    }

    @bind
    private async _getUploadedImages():Promise<UploadedImage[]>
    {
        const openDesign = commonControllers.designState.getOpenDesign();

        if( openDesign )
            return openDesign.designState.assets.uploadedImages.map(this._deserializeUploadedImageSnapshot);

        return [];
    }

    @bind
    private async _searchUploadedImages(text:string, uploadedImages?:UploadedImage[]):Promise<UploadedImage[]>
    {
        uploadedImages = uploadedImages || await this._getUploadedImages();

        return uploadedImages.filter(({label}) => label.indexOf(text) !== -1);
    }

    @bind
    private async _getUploadedImage(name:string):Promise<UploadedImage>
    {
        const openDesign = commonControllers.designState.getOpenDesign();

        if( openDesign )
        {
            const designUploadedImage:DesignUploadedImage = openDesign.designState.assets.uploadedImages.find((
                (uploadedImage:DesignUploadedImage) => uploadedImage.name === name
            ));

            if( designUploadedImage )
                return this._deserializeUploadedImageSnapshot(designUploadedImage);
        }

        return null;
    }

    @bind
    private _deserializeUploadedImageSnapshot(snapshot:DesignUploadedImage):UploadedImage
    {
        return new UploadedImage(snapshot.name, snapshot.label, snapshot.url);
    }
}
